<template>
  <div>
    <div
      class="turning-btn"
      :class="screenHome ? '' : 'active'"
      @click="show()"
    >
      <span class="top" />
      <span class="bottom" />
    </div>
    <div class="contents-wrapper">
      <div class="contents-header">
        <div class="nav">
          <router-link to="/">
            <img :src="scroll_event_homeImage" />
          </router-link>
        </div>
      </div>
      <div class="contents-body">
        <div class="contents-body__left">
          <project-thumb
            v-for="(project, index) in projectList['left']"
            :key="index"
            :index="index"
            :image="project.thumbnail_image"
            :position="project.screen_position"
            :role="project.role"
            :title="project.project_name"
            :year="project.year"
            @click="move(project.url)"
          />
        </div>
        <div class="contents-body__right">
          <project-thumb
            v-for="(project, index) in projectList['right']"
            :key="index"
            :index="index"
            :image="project.thumbnail_image"
            :position="project.screen_position"
            :role="project.role"
            :title="project.project_name"
            :year="project.year"
            @click="move(project.url)"
          />
        </div>
      </div>
      <div class="contents-footer">
        <span class="name">
          <img src="/images/home_full_name.svg" />
        </span>
        <span class="copyright">
          <p>2021 ⓒ ahnyuri</p>
        </span>
      </div>
    </div>
    <div class="career">
      <h1 style="margin-top: 50px; margin-left: 10%; font-size: 36px">
        Yuri Ahn<br />UX/UI, Graphic designer<br />elisabet517@naver.com
      </h1>

      <p style="margin-top: 50px; margin-left: 20%; font-size: 12px">
        Awards & Recognition
      </p>
      <h1 style="margin-top: 10px; margin-left: 20%; font-size: 36px">
        iF design awards: Gold awards '11/<br />Reddot design awards: Winner
        '10/<br />WOLDA(the worldwide logo design annual):<br />
        professional ’10/ 1st Dove creative<br />artwork awards: Silver awards
        '07<br />
      </h1>

      <p style="margin-top: 50px; margin-left: 30%; font-size: 12px">
        Educational background
      </p>
      <h1
        style="
          margin-top: 10px;
          margin-left: 30%;
          margin-bottom: 60px;
          font-size: 36px;
        "
      >
        Dept. of Visual design,<br />Univ. of Hongik, Master’s degree/<br />Dept.
        of Visual package design,<br />Univ. of Hanyang ERICA,<br />Bachelor’s
        degree
      </h1>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ProjectThumb from "@/components/ProjectThumb";
import {ScrollEventMixin} from "@/mixins/ScrollEventMixin"

import { PROJECT_LIST } from "@/constant";
import { bg_util_debounce } from "@/modules/util";
import { fadeIn, fadeOut } from "@/modules/fadeInAndOut";

export default {
  name: "Home",
  components: { ProjectThumb },
  mixins: [ScrollEventMixin],
  data() {
    return {
      screenHome: true,
      scrollHandler: null,
      projectList: PROJECT_LIST,
    };
  },
  created() {
    
  },
  methods: {
    show() {
      this.screenHome = !this.screenHome;
      const el = document.querySelector(".contents-wrapper");
      const el2 = document.querySelector(".career");
      if (!this.screenHome) {
        fadeOut(el);
        fadeIn(el2);
      }else {
        fadeOut(el2);
        fadeIn(el);
      }
    },
    move(url) {
      this.$router.push(`/detail/${url}`)
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/HomeBtn.scss";
@import "@/views/HomeHeader.scss";
@import "@/views/HomeBody.scss";
@import "@/views/HomeFooter.scss";
@import "@/views/HomeCareer.scss";
.contents-wrapper {
  overflow-x: hidden;
}
.test {
  fill: red;
}
</style>
